import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { Picker,Popup, Popover, Button, Area } from 'vant';
import 'vant/lib/index.css';
import "@/style/index.css";
import Vant from 'vant';

import '@/assets/less/main.less'
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/notify/style'
import 'vant/es/image-preview/style'
import Varlet from '@varlet/ui'
import '@varlet/ui/es/style'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'


const app = createApp(App)
app.use(Picker)
app.use(Popup)
app.use(Vant)
app.use(Button)
app.use(Area)
app.use(Popover)
app.use(Varlet)
app.use(router)
app.use(ElementPlus)
app.mount('#app')
